import ModalsProvider from "./ModalsProvider";
import ModalsContext from "./context";

export default ModalsContext;
export { ModalsProvider };
